export default __webpack_public_path__ + "static/media/pwp.754ac099.jpg";